import { scheduleDates } from '../../../../context';
import { JobDraftState } from '../../../context';

type WorkerInvite = {
  worker_id: number;
  worker_name: string;
  job_skill_id: number;
  job_skill_name: string;
  schedule_group_id: number;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  shift_dates: string[];
};

export type InvitePayload = {
  invited_workers: WorkerInvite[];
  hired_workers: WorkerInvite[];
};

export const buildInvitePayload = (jobs: JobDraftState[]): InvitePayload => {
  const invitedWorkers: WorkerInvite[] = [];
  const hiredWorkers: WorkerInvite[] = [];

  jobs.forEach((job) => {
    job.schedules.forEach((schedule) => {
      const shiftDates = scheduleDates(schedule).map(
        (date) => date.toISOString().split('T')[0],
      );
      const startDate =
        schedule.dateRange.startDate?.toISOString().split('T')[0] || '';
      const endDate =
        schedule.dateRange.endDate?.toISOString().split('T')[0] || '';

      schedule.selectedWorkers?.forEach((worker) => {
        invitedWorkers.push({
          worker_id: Number(worker.id),
          worker_name: worker.user
            ? `${worker.user.firstName} ${worker.user.lastName}`
            : '',
          job_skill_id: Number(job.skill?.id),
          job_skill_name: job.skill?.name || '',
          schedule_group_id: schedule.groupId,
          start_date: startDate,
          end_date: endDate,
          start_time: schedule.startTime,
          end_time: schedule.endTime,
          shift_dates: shiftDates,
        });
      });

      schedule.hiredWorkers?.forEach((worker) => {
        hiredWorkers.push({
          worker_id: Number(worker.id),
          worker_name: worker.user
            ? `${worker.user.firstName} ${worker.user.lastName}`
            : '',
          job_skill_id: Number(job.skill?.id),
          job_skill_name: job.skill?.name || '',
          schedule_group_id: schedule.groupId,
          start_date: startDate,
          end_date: endDate,
          start_time: schedule.startTime,
          end_time: schedule.endTime,
          shift_dates: shiftDates,
        });
      });
    });
  });

  return {
    invited_workers: invitedWorkers,
    hired_workers: hiredWorkers,
  };
};
